
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service/buyer/search",
      function () {
        return require("private-next-pages/service/buyer/search/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service/buyer/search"])
      });
    }
  